/* global axios */
import ApiClient from './ApiClient';

class TaxiClientsAPI extends ApiClient {
  constructor() {
    super('taxi_clients', { accountScoped: true });
  }

  getAll() {
    return axios.get(this.url);
  }

  create(data) {
    return axios.post(this.url, { taxi_client: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { taxi_client: data });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  createTrip(clientId, data) {
    return axios.post(`${this.url}/${clientId}/trips`, {
      taxi_client_trip: data,
    });
  }

  deleteTrip(clientId, tripId) {
    return axios.delete(`${this.url}/${clientId}/trips/${tripId}`);
  }
}

export default new TaxiClientsAPI();
